module.exports = __webpack_public_path__ + "svg/roulette-timer-big.svg?8eabcddb2a3dbdc6ef0d5044619d9f16";